<template>
	<div
		data-aos="fade-up"
		class="relative min-h-80 border-2 border-foreground rounded-2xl p-5 backdrop-blur-8">
		<div class="flex flex-col gap-2">
			<h3 class="text-xl">
				پشتیبانی از مدل های پیشرفته و جدید
			</h3>

			<p class="text-foreground/60">
				از مدل های مختلف و به روز با یک پلن استفاده کنید.
			</p>
		</div>

		<NewModelsBeam />
	</div>
</template>
